// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CollapsedActivityPreview-cls1__e487d3c6561c55349267{/*!*/}.CollapsedActivityPreview-cls2__bfdb9f534496404d35c7{flex-shrink:0;margin:4px 0}@media(min-width: 768px){.CollapsedActivityPreview-cls2__bfdb9f534496404d35c7{width:132px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CollapsedActivityPreview-cls1__e487d3c6561c55349267",
	"cls2": "CollapsedActivityPreview-cls2__bfdb9f534496404d35c7 CollapsedActivityPreview-cls1__e487d3c6561c55349267"
};
export default ___CSS_LOADER_EXPORT___;
